import React from "react";

import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { VariantButtonView } from "./VariantButtonView";
import { VariantPickerSharedProperties, VariantPickerVariation_Plain } from "../utils";

export const PlainVariantView: ReactTFC<{
  variation: Omit<VariantPickerVariation_Plain, "tag">;
  action: VariantPickerSharedProperties["target"];
  className: string;
}> = props => {
  return (
    <VariantButtonView
      name={props.variation.name}
      target={props.variation.target}
      isNew={props.variation.isNew}
      state={props.variation.state}
      gridLess={true}
      className={props.className}
    />
  );
};
